import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, RequireAuth } from './lib/auth';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import FansPage from './pages/FansPage';
import NotificationsPage from './pages/NotificationsPage';
import AccountsPage from './pages/AccountsPage';
import SuperAdminPage from './pages/SuperAdminPage';
import { useAuth } from './lib/auth';

function RequireSuper({ children }: { children: JSX.Element }) {
  const { user } = useAuth();
  if (!user || user.role !== 'super') return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="fans" element={<FansPage />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="accounts" element={<AccountsPage />} />
          <Route path="super" element={<RequireSuper><SuperAdminPage /></RequireSuper>} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
